module.exports = __webpack_public_path__ + "img/118.8.b15ca927.png";